import React, { useContext } from "react";
import { GlobalState } from "../../Helper/Context";
const ListUlIcon = () => {
  const { state, setState } = useContext(GlobalState);

  return (
    <svg
      onClick={() => {
        setState({ ...state, listMode: "grid" });
        localStorage.setItem("listMode", "grid");
      }}
      className="w-6 cursor-pointer"
      x="0px"
      y="0px"
      viewBox="0 0 128 128"
      opacity={state.listMode == "grid" ? 1 : 0.3}
    >
      <path
        d="M15.3,15.3C9.1,15.3,4,20.3,4,26.5s5,11.2,11.2,11.2s11.2-5,11.2-11.2S21.5,15.3,15.3,15.3z M15.3,52.8
	C9.1,52.8,4,57.8,4,64s5,11.2,11.2,11.2s11.2-5,11.2-11.2S21.5,52.8,15.3,52.8z M15.3,90.2c-6.2,0-11.2,5-11.2,11.2
	c0,6.2,5,11.2,11.2,11.2s11.2-5,11.2-11.2C26.5,95.3,21.5,90.2,15.3,90.2z"
      />
      <path
        d="M64,15.3c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2s11.2-5,11.2-11.2S70.2,15.3,64,15.3z M64,52.8c-6.2,0-11.2,5-11.2,11.2
	s5,11.2,11.2,11.2s11.2-5,11.2-11.2S70.2,52.8,64,52.8z M64,90.2c-6.2,0-11.2,5-11.2,11.2c0,6.2,5,11.2,11.2,11.2s11.2-5,11.2-11.2
	C75.2,95.3,70.2,90.2,64,90.2z"
      />
      <path
        d="M112.7,15.3c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2S118.9,15.3,112.7,15.3z M112.7,52.8
	c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2S118.9,52.8,112.7,52.8z M112.7,90.2c-6.2,0-11.2,5-11.2,11.2
	c0,6.2,5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2C124,95.3,118.9,90.2,112.7,90.2z"
      />
    </svg>
  );
};

export default ListUlIcon;
